import React from 'react';

import { FormattedMessage } from '../../../util/reactIntl';
import { FittedImage } from '../../../components';

import css from './ClassDetail.module.css';

// Thumbnails shown before the "+N more" tile.
const STRIP_THUMBNAILS = 3;

/**
 * "More photos from the studio" -- gallery thumbnails after the hero. Renders only when the listing
 * has more than the hero image; every affordance opens the shared image-carousel modal.
 */
const ClassPhotoStrip = props => {
  const { listing, onOpenGallery } = props;
  const images = listing.images || [];
  const galleryImages = images.slice(1);

  if (galleryImages.length === 0) {
    return null;
  }

  const thumbnails = galleryImages.slice(0, STRIP_THUMBNAILS);
  const moreCount = galleryImages.length - thumbnails.length;

  return (
    <section className={css.photoStrip}>
      <div className={css.photoStripHeader}>
        <div>
          <h2 className={css.sectionTitle}>
            <FormattedMessage id="ClassDetailPage.morePhotosTitle" />
          </h2>
          <p className={css.sectionSubtitle}>
            <FormattedMessage id="ClassDetailPage.morePhotosSubtitle" />
          </p>
        </div>
        <button type="button" className={css.viewGallery} onClick={onOpenGallery}>
          <FormattedMessage id="ClassDetailPage.viewGallery" />
        </button>
      </div>
      <div className={css.photoStripGrid}>
        {thumbnails.map(image => (
          <button
            key={image.id?.uuid}
            type="button"
            className={css.photoThumb}
            onClick={onOpenGallery}
          >
            {/* The shared fit-not-crop treatment (FittedImage). */}
            <FittedImage
              className={css.photoThumbImage}
              alt={listing.attributes?.title || ''}
              image={image}
              sizes="(max-width: 767px) 50vw, 280px"
            />
          </button>
        ))}
        {moreCount > 0 ? (
          <button type="button" className={css.morePhotosTile} onClick={onOpenGallery}>
            <FormattedMessage id="ClassDetailPage.morePhotos" values={{ count: moreCount }} />
          </button>
        ) : null}
      </div>
    </section>
  );
};

export default ClassPhotoStrip;
